import produce from 'immer';
import {
  GET_REFERRAL_RULES_START,
  GET_REFERRAL_RULES_SUCCESS,
  GET_REFERRAL_RULES_FAILED,
  SAVE_REFERRAL_RULE_START,
  SAVE_REFERRAL_RULE_SUCCESS,
  SAVE_REFERRAL_RULE_FAILED,
  DELETE_REFERRAL_RULE_START,
  DELETE_REFERRAL_RULE_SUCCESS,
  DELETE_REFERRAL_RULE_FAILED,
  SET_EDITABLE_REFERRAL_RULE
} from '../actions/referral_program';


const initialState = {
  referralRulesList: [],
  loadingReferralRules: false,
  editableReferralRule: {},
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_REFERRAL_RULES_START: {
      state.loadingReferralRules = true;
      break;
    }

    case GET_REFERRAL_RULES_SUCCESS: {
      const { data } = action;
      state.referralRulesList = data;
      state.loadingReferralRules = false;

      break;
    }

    case GET_REFERRAL_RULES_FAILED: {
      state.loadingReferralRules = false;
      break;
    }

    case SAVE_REFERRAL_RULE_START: {
      state.loadingReferralRules = true;
      break;
    }

    case SAVE_REFERRAL_RULE_SUCCESS: {
      const { data } = action;

      state.referralRulesList = [...state.referralRulesList, {data}];
      state.loadingReferralRules = false;

      break;
    }

    case SAVE_REFERRAL_RULE_FAILED: {
      state.loadingReferralRules = false;
      break;
    }

    case DELETE_REFERRAL_RULE_START: {
      state.loadingReferralRules = true;
      break;
    }

    case DELETE_REFERRAL_RULE_SUCCESS: {
      const { data } = action;
      state.referralRulesList = state.referralRulesList.filter((rule) => rule.rule_id != data.rule_id);
      state.loadingReferralRules = false;

      break;
    }

    case DELETE_REFERRAL_RULE_FAILED: {
      state.loadingReferralRules = false;
      break;
    }

    case SET_EDITABLE_REFERRAL_RULE: {
      const { rule } = action;
      state.editableReferralRule = rule;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
